import React from 'react';
import { useNavigate } from 'react-router-dom';
import './Hero.css';

// Import images
import heroBgPattern from '../../static/hero_bg_pattern_figma.svg';
import heartIcon from '../../static/heart_hero.svg';
import starIcon from '../../static/star_hero.svg';
import magicalEffect from '../../static/fil_ariane.svg';
import image1Hero from '../../static/image_1_hero.png';
import image2Hero from '../../static/image_2_hero.png';
import image3Hero from '../../static/image_3_hero.png';

const Hero = () => {
  const navigate = useNavigate();

  const handleCreateBook = () => {
    navigate('/create/1-write');
  };

  return (
    <div className="hero-section-component">
      {/* Purple background layer */}
      <div className="hero-bg-color"></div>
      
      {/* Pattern background layer */}
      <div className="hero-background">
        <img src={heroBgPattern} alt="" aria-hidden="true" />
      </div>
      
      {/* Decorative elements */}
      <svg className="dashed-line top" viewBox="0 0 200 100">
        <path d="M10,50 Q60,10 100,50 T190,50" />
      </svg>
      <svg className="dashed-line middle" viewBox="0 0 250 50">
        <path d="M10,25 Q60,10 120,40 T240,25" />
      </svg>
      <svg className="dashed-line bottom" viewBox="0 0 300 50">
        <path d="M10,25 Q90,40 150,10 T290,25" />
      </svg>
      
      <div className="decoration-dot orange"></div>
      <div className="decoration-dot purple"></div>
      
      <div className="magical-swirl">
        <svg viewBox="0 0 100 100" fill="none">
          <path d="M50,90 Q10,50 50,10 Q90,50 50,90 Z" stroke="currentColor" strokeWidth="2" fill="none" />
        </svg>
      </div>
      
      <div className="content-wrapper">
        <div className="text-content">
          <div className="text-header">
            <div className="brand-name self-stretch justify-start">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z" fill="currentColor" />
              </svg>
              Magical AI Stories
            </div>
            
            <div className="text-content-inner">
              <h2 className="w-[635px] justify-start text-black font-medium font-['Baloo_2'] leading-[90px]">Create a Book That Will Spark Your Child's Imagination</h2>
              <div className="text-content-body">
                <p>
                  Create a unique children's story with our easy-to-use ai storybook maker. 
                  Our personalized children's books are fully customized with original characters, 
                  illustrations, and an imaginative plot. Our text-to-speech narration feature 
                  makes reading even more fun and engaging. Start creating your own children's 
                  story today!
                </p>
              </div>
            </div>
          </div>
          
          <button className="create-book-btn" onClick={handleCreateBook}>
            <div className="btn-icon">
              <svg width="20" height="20" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clipPath="url(#clip0_10_1646)">
                  <path d="M12.5 0C5.88294 0 0.5 5.38294 0.5 12C0.5 18.6171 5.88294 24 12.5 24C19.1171 24 24.5 18.6171 24.5 12C24.5 5.38294 19.1171 0 12.5 0ZM17.75 12.9999H13.4999V17.25C13.4999 17.802 13.052 18.2499 12.5 18.2499C11.948 18.2499 11.5001 17.802 11.5001 17.25V12.9999H7.25C6.69795 12.9999 6.25006 12.552 6.25006 12C6.25006 11.448 6.69795 11.0001 7.25 11.0001H11.5001V6.75C11.5001 6.19795 11.948 5.75006 12.5 5.75006C13.052 5.75006 13.4999 6.19795 13.4999 6.75V11.0001H17.75C18.302 11.0001 18.7499 11.448 18.7499 12C18.7499 12.552 18.302 12.9999 17.75 12.9999Z" fill="white"/>
                </g>
                <defs>
                  <clipPath id="clip0_10_1646">
                    <rect width="24" height="24" fill="white" transform="translate(0.5)"/>
                  </clipPath>
                </defs>
              </svg>
            </div>
            Create a Book
          </button>
        </div>
        
        <div className="image-gallery">
          <div className="image-grid">
            {/* Main image (top) */}
            <div className="main-image">
              <img 
                src={image1Hero} 
                alt="Parent reading a book to children"
              />
              <img src={heartIcon} alt="" className="decoration-element heart-element" aria-hidden="true" />
            </div>
            
            {/* Secondary image (bottom left) */}
            <div className="secondary-image">
              <img 
                src={image2Hero}
                alt="Child reading a book"
              />
              <img src={starIcon} alt="" className="decoration-element star-element" aria-hidden="true" />
            </div>
            
            {/* Secondary image (bottom right) */}
            <div className="secondary-image">
              <img 
                src={image3Hero}
                alt="Child with magical book effect"
              />
              <div className="magical-effect">
                <img src={magicalEffect} alt="" aria-hidden="true" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Hero;